import {action, observable, makeObservable} from 'mobx';
import {CheckedValue} from '../ToggleButton/enum';

class MailboxSendToggleStore {
    @observable uiState: CheckedValue = CheckedValue.right;

    constructor() {
        makeObservable(this);
    }

    @action
    toggleUIState = (flag: CheckedValue) => {
        this.uiState = flag;
    };
}

export const mailboxSendToggleStore = new MailboxSendToggleStore();
